import styled, { createGlobalStyle, keyframes } from 'styled-components'
import { Select } from 'antd'

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: 'Nunito', Arial, sans-serif;
    background: #edf1f8;
  }
`

export const Page = styled.div`
  min-height: 100vh;
  padding: 28px 32px;

  @media (max-width: 960px) {
    padding: 20px 16px;
  }
`

export const Topbar = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`

export const FixedTopbar = styled(Topbar)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: 64px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 24px;
`

export const Title = styled.h1`
  margin: 0;
  font-size: 38px;
  font-weight: 800;
  color: #1e3a5f;
  letter-spacing: -0.5px;

  @media (max-width: 600px) {
    font-size: 28px;
  }
`

export const StyledTitle = styled(Title)`
    margin: 0px;
    font-size: 38px;
    font-weight: 800;
    color: rgb(30, 58, 95);
    letter-spacing: -0.5px;
`

export const Username = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2d4f80;
  font-weight: 700;
  font-size: 14px;
  background: white;
  padding: 9px 16px;
  border-radius: 100px;
  box-shadow: 0 2px 12px rgba(42, 76, 129, 0.13);
  border: 1px solid #dce8f7;

  &::before {
    content: '';
    display: inline-block;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4a6fb0, #6b93d6);
    flex-shrink: 0;
  }

  @media (max-width: 600px) {
    display: none;
  }
`

export const Content = styled.div`
  gap: 24px;
  display: flex;
  align-items: flex-start;
  width: 100%;

  @media (width < 960px) {
    flex-direction: column;
  }
`

export const ContentWithOffset = styled(Content)`
  margin-top: 80px;
`

export const Sidebar = styled.aside`
  width: 280px;
  flex-shrink: 0;
  background: white;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(42, 76, 129, 0.1);
  border: 1px solid #dce8f7;
  position: sticky;
  top: ${({ $fixed }) => ($fixed ? 'calc(64px + 20px)' : '28px')};
  max-height: ${({ $fixed }) =>
        $fixed ? 'calc(100vh - 64px - 20px - 20px)' : 'none'};
  overflow-y: auto;
  align-self: flex-start;

  scrollbar-width: thin;
  scrollbar-color: #d1d1d1 transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d1d1d1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  @media (max-width: 960px) {
    width: 100%;
    flex: 1 1 auto;
    position: static;
    max-height: none;
    overflow-y: visible;
  }
`

export const SidebarLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #8aa4c8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 10px;
  margin-top: 4px;
`

export const ModeSwitch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 22px;
  background: #f0f5fc;
  border-radius: 14px;
  padding: 6px;

  @media (max-width: 960px) {
    flex-direction: row;
  }
`

export const ModeBtn = styled.button`
  width: 100%;
  padding: 11px 14px;
  border-radius: 10px;
  border: none;
  background: transparent;
  font-family: 'Nunito', Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #6888b0;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  text-align: left;

  &:hover {
    background: white;
    color: #2d4f80;
  }

  ${({ $active }) =>
        $active &&
    `
    background: white;
    color: #3a62a0;
    box-shadow: 0 2px 10px rgba(42, 76, 129, 0.14);
  `}
`

export const DateFilterCard = styled.div`
  margin-bottom: 22px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #dce8f7;
  background: #f6f9fe;
  color: #2d4f80;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ClearFilterButton = styled.button`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #dce8f7;
  background: #fff;
  color: #6888b0;
  font-family: 'Nunito', Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s, color 0.18s, box-shadow 0.18s;
  margin-top: 10px;

  &:hover {
    background: #eef4fd;
    color: #2d4f80;
  }
`

export const DateFilterFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 960px) {
    flex-direction: row;
  }

  @media (max-width: 410px) {
    flex-direction: column;
  }
`

export const DateField = styled.label`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #8aa4c8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const DateInput = styled.input`
  width: 100%;
  padding: 11px 14px;
  border-radius: 12px;
  border: 1.5px solid #dce8f7;
  background: white;
  font-family: 'Nunito', Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #2d4f80;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;

  &:focus {
    border-color: #4a6fb0;
    box-shadow: 0 0 0 3px rgba(74, 111, 176, 0.12);
  }
`

export const ScheduleArea = styled.main`
  width: 100%;
  flex: 1;
  min-width: 0;
  padding: 20px;
  min-height: 500px;
`

export const DaySection = styled.section`
  margin-bottom: 30px;
  animation: ${keyframes`
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  `} 0.25s ease both;
`

export const DayBlock = DaySection

export const DayTitle = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 800;
  color: #4a6fb0;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 12px;
  padding: 7px 16px;
  background: white;
  border-radius: 100px;
  box-shadow: 0 2px 8px rgba(42, 76, 129, 0.1);
  border: 1px solid #dce8f7;

  &::before {
    content: '';
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #4a6fb0;
  }
`

export const LessonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LessonCard = styled.div`
  display: grid;
  grid-template-columns: 52px 1fr auto auto;
  align-items: center;
  gap: 18px;
  background: white;
  border-radius: 16px;
  padding: 16px 20px;
  box-shadow: 0 2px 10px rgba(42, 76, 129, 0.07);
  border: 1px solid #dce8f7;
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s, background 0.2s;

  ${({ $isWindow }) =>
        $isWindow &&
    `
    background: repeating-linear-gradient(
      -45deg,
      #f5f8fc,
      #f5f8fc 10px,
      #eef3f9 10px,
      #eef3f9 20px
    );
    border: 1.5px dashed #9eb6d4;
    box-shadow: none;
  `}

  &:hover {
    box-shadow: ${({ $isWindow }) =>
        $isWindow
            ? '0 4px 16px rgba(42, 76, 129, 0.1)'
            : '0 6px 24px rgba(42, 76, 129, 0.15)'};
    border-color: ${({ $isWindow }) => ($isWindow ? '#4a6fb0' : '#b8cfe8')};
    background: ${({ $isWindow }) => ($isWindow ? '#f0f5fc' : 'white')};
    transform: ${({ $editing }) => ($editing ? 'none' : 'translateY(-2px)')};
  }

  @media (max-width: 960px) {
    grid-template-columns: 44px 1fr 0.2fr;
    gap: 12px;
  }
`

export const LessonEditCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 18px;
  background: white;
  border-radius: 16px;
  padding: 16px 20px;
  box-shadow: 0 2px 10px rgba(42, 76, 129, 0.07);
  border: 1px solid #dce8f7;
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;

  ${({ $isWindow }) =>
        $isWindow &&
    `
    border: 1.5px dashed #9eb6d4;
    background: #f7fafd;
  `}

  &:hover {
    box-shadow: 0 6px 24px rgba(42, 76, 129, 0.15);
    border-color: ${({ $isWindow }) => ($isWindow ? '#4a6fb0' : '#b8cfe8')};
    transform: ${({ $editing }) => ($editing ? 'none' : 'translateY(-2px)')};
  }

  @media (max-width: 960px) {
    flex-direction: ${({ $editing }) => ($editing ? 'row' : 'column')};
    gap: ${({ $editing }) => ($editing ? '12px' : '24px')};
    padding: ${({ $editing }) => ($editing ? '12px' : '16px 20px')};
  }
`

export const EditorFormSection = styled.div`
  flex: 1;
  min-width: 0;
  width: 50%;
`

export const EditorOccupancySection = styled.div`
  flex: 1;
  min-width: 0;
  width: 50%;
  display: flex;
`

export const LessonNumber = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 12px;
  background: ${({ $isWindow }) => ($isWindow ? '#e2ebf5' : '#eef4fd')};
  border: ${({ $isWindow }) => ($isWindow ? '1.5px dashed #9eb6d4' : 'none')};
  font-size: 20px;
  font-weight: 800;
  color: ${({ $isWindow }) => ($isWindow ? '#7a93b5' : '#4a6fb0')};
`

export const WindowBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px dashed #9eb6d4;
  background: #eef4fd;
  color: #4a6fb0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`

export const LessonMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const LessonSubject = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #1e3a5f;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LessonMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: #8aa4c8;
  font-size: 13px;
  font-weight: 500;

  b {
    color: #6888b0;
    font-weight: 700;
  }
`

export const LessonTeacher = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2d4f80;
  text-align: right;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 960px) {
    display: none;
  }
`

export const LessonRoom = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #eef4fd;
  font-size: 14px;
  font-weight: 700;
  color: #4a6fb0;
  white-space: nowrap;

  @media (max-width: 960px) {
    display: none;
  }
`

export const StateBox = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px 24px;
  font-weight: 600;
  font-size: 15px;
  box-shadow: 0 2px 10px rgba(42, 76, 129, 0.07);
  border: 1px solid #dce8f7;
`

export const ErrorBox = styled(StateBox)`
  border-left: 4px solid #e05555;
  color: #b02a37;
`

export const EmptyBox = styled(StateBox)`
  text-align: center;
  color: #8aa4c8;
  padding: 48px 24px;
`

export const Loading = styled(StateBox)`
  text-align: center;
  color: #8aa4c8;
  padding: 48px 24px;
`

export const StatusText = styled.div`
  font-size: 16px;
  color: #2d4a78;
`

export const ActionButton = styled.button`
  padding: 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  background: #4a6fb0;
  color: white;
`

export const SecondaryButton = styled.button`
  padding: 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  background: #e5e7eb;
  color: #243954;
`

export const EditButton = styled(SecondaryButton)`
  background: #dfeaff;
  color: #2d4a78;
`

export const DeleteButton = styled.button`
  max-height: 36px;
  border: none;
  border-radius: 10px;
  padding: 9px 12px;
  font-weight: 600;
  background: #ffe0e0;
  color: #8b2f2f;
  cursor: pointer;

  &:hover {
    background: #ffd0d0;
  }
`

export const AddButton = styled.button`
  position: fixed;
  right: 30px;
  bottom: 30px;
  background: #4a6fb0;
  color: white;
  border: none;
  padding: 14px 18px;
  border-radius: 999px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(74, 111, 176, 0.3);
  transition: 0.2s;
  z-index: 1000;

  &:hover {
    background: #3d5a92;
    transform: scale(1.05);
  }

  @media (max-width: 1000px) {
    right: 20px;
    bottom: 20px;
  }
`

export const StyledButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 24px;
  background: #257cee;
  color: white;
  border: none;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  transition: 0.2s;

  &:hover {
    background: #116ce4;
    transform: translateY(-2px);
  }
`

export const ShowMoreButton = styled.button`
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #dce8f7;
  background: #fff;
  color: #6888b0;
  font-family: 'Nunito', Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 10px;
`

// ---- Поля формы ----
export const Field = styled.input`
  width: 100%;
  padding: 7px;
  border-radius: 6px;
  border: 1px solid #cfd9ea;
  font-size: 14px;
`

export const InlineForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px 16px;
`

export const InlineField = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  color: #243954;
  font-size: 14px;
`

export const InlineLabel = styled.span`
  font-weight: 700;
  color: #1f2d3d;
`

export const InlineHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  grid-column: 1 / -1;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`

export const InlineActions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
`

export const InlineSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    min-height: 42px !important;
    border-radius: 10px !important;
    border-color: #cfd9ea !important;
    padding: 5px 12px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 30px !important;
  }
`

export const GroupSelect = styled.select`
  width: 100%;
  padding: 11px 36px 11px 14px;
  border-radius: 12px;
  border: 1.5px solid #dce8f7;
  background: #f6f9fe;
  font-family: 'Nunito', Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #2d4f80;
  line-height: normal;
  outline: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%238aa4c8' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  transition: border-color 0.18s, box-shadow 0.18s;

  &::-ms-expand {
    display: none;
  }

  &:focus {
    border-color: #4a6fb0;
    box-shadow: 0 0 0 3px rgba(74, 111, 176, 0.12);
  }
`

export const OccupancyCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
  width: 100%;
  padding: 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  border: 1px solid #dce8f7;
  box-shadow: 0 8px 24px rgba(42, 76, 129, 0.08);

  @media (max-width: 960px) {
    padding: 12px;
    gap: 12px;
  }
`

export const OccupancyHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const OccupancyTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #1e3a5f;
`

export const OccupancySubtitle = styled.div`
  font-size: 13px;
  color: #7d93b4;
`

export const OccupancyGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const OccupancyRow = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(5px, 2vw, 16px);
  padding: 6px 8px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid
    ${({ $busy, $active }) =>
        $busy
            ? '#f5d0c9'
            : $active
                ? '#b8d9a8'
                : '#e8edf4'};
  box-shadow: ${({ $busy, $active }) =>
        $busy
            ? '0 4px 12px rgba(211, 90, 74, 0.15)'
            : $active
                ? '0 4px 12px rgba(94, 168, 65, 0.15)'
                : '0 2px 8px rgba(0, 0, 0, 0.04)'};
  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    border-color: ${({ $busy, $active }) =>
        $busy ? '#e6b3a8' : $active ? '#a3cf8a' : '#cbd8e6'};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
    padding: 5px;
  }
`

export const OccupancyLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
  color: #1a2b3c;

  @media (max-width: 768px) {
    min-width: auto;
    text-align: center;
  }
`

export const OccupancyPillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  gap: 8px;
  flex: 1;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const OccupancyPill = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 14px;
  background: ${({ $busy }) => ($busy ? '#fff4f2' : '#f4fbf2')};
  border: 1px solid ${({ $busy }) => ($busy ? '#f1c0b8' : '#d8ebd5')};
  min-width: 0;

  @media (max-width: 768px) {
    padding: 6px 7px;
  }
`

export const OccupancyPillTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #282f3a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const OccupancyPillState = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 800;
  color: ${({ $busy }) => ($busy ? '#b34c3d' : '#2f8f3a')};
`

export const OccupancyPillDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 4px;
  background: ${({ $busy }) => ($busy ? '#d96a58' : '#89cf79')};
  flex-shrink: 0;
`

export const OccupancyLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
  font-size: 13px;
  color: #5f7495;
`

export const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  span {
    font-weight: 700;
  }
`

export const LegendDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 5px;
  background: ${({ $busy }) => ($busy ? '#d96a58' : '#89cf79')};
`

export const OccupancyHint = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 14px;
  background: ${({ $busy }) => ($busy ? '#fad6d0' : '#eef8e9')};
  color: ${({ $busy }) => ($busy ? '#b34c3d' : '#2f8f3a')};
  font-size: 14px;
  font-weight: 700;
`

export const OccupancyHintIcon = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid currentColor;
  font-size: 15px;
  flex-shrink: 0;
`

export const OccupancyPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  width: 100%;
  padding: 40px 20px;
  text-align: center;
  color: #6b7a8a;
  font-size: 15px;
  background: #f8faff;
  border-radius: 16px;
  border: 2px dashed #d0dbe8;

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  p {
    margin: 4px 0 0;
    font-size: 14px;
    opacity: 0.7;
  }

  @media (max-width: 960px) {
    padding: 16px 10px;
    font-size: 13px;

    svg {
      width: 32px;
      height: 32px;
      margin-bottom: 10px;
    }

    p {
      font-size: 12px;
    }
  }
`

export const OccupancyStatus = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ $busy }) => ($busy ? '#b34c3d' : '#2f8f3a')};
`

export const OccupancyDot = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 6px;
  background: ${({ $busy }) => ($busy ? '#d96a58' : '#89cf79')};
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
`

export const TopbarUsername = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: #2d4f80;
    font-weight: 700;
    font-size: 14px;
    padding: 9px 16px;
    border-radius: 100px;
    background: white;
    box-shadow: 0 2px 12px rgba(42, 76, 129, 0.13);
    border: 1px solid #dce8f7;
    white-space: nowrap;

    &::before {
        content: '';
        display: inline-block;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: linear-gradient(135deg, #4a6fb0, #6b93d6);
        flex-shrink: 0;
    }
`